import { useStrings } from "@1js/localization-components";
import { Button, Text, Tooltip, makeStyles } from "@fluentui/react-components";
import { SettingsRegular } from "@fluentui/react-icons";
import * as React from "react";
import { useSearchParams } from "react-router-dom";
import {
  FailureStopShareToastMessage,
  ManageAccessDialogTitle,
  SuccessStopShareToastMessage,
} from "./ManageSharedPrompts.strings";

const useStyles = makeStyles({
  text: {
    fontFamily: "Segoe UI",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "137.5%",
    "@media (max-width: 800px)": {
      display: "none",
    },
  },
});

export const ManageSharedPromptsButton: React.FC = () => {
  const strings = useStrings({
    SuccessStopShareToastMessage,
    FailureStopShareToastMessage,
    ManageAccessDialogTitle,
  });
  const styles = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();

  const openDialog = () => {
    searchParams.set("manageAccess", "open");
    setSearchParams(searchParams);
  };

  return (
    <Tooltip content={strings.ManageAccessDialogTitle()} relationship="label">
      <Button
        appearance="transparent"
        icon={<SettingsRegular />}
        onClick={openDialog}
      >
        <Text className={styles.text}>{strings.ManageAccessDialogTitle()}</Text>
      </Button>
    </Tooltip>
  );
};
